import { createContext } from 'react';
import { ConsoleLogger } from './console-logger';

/**
 * Context for the error reporter, defaults
 * to console.* methods
 */
export var LoggerContext = /*#__PURE__*/createContext(new ConsoleLogger());